/* ============================================================
   Lebby PDP — smooth accordion roll-out (Phase 2 enhancement)
   Native <details> toggles instantly and can't be CSS-transitioned
   on close, so we animate the element height both ways with the
   Web Animations API. Progressive enhancement: without JS the
   accordions still open/close (instantly). Respects reduced-motion.
   ============================================================ */
(function () {
  var DURATION = 550;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function LebbyAccordion(detailsEl) {
    this.el = detailsEl;
    this.summary = detailsEl.querySelector('summary');
    this.content = detailsEl.querySelector('.lebby-acc__content');
    if (!this.summary || !this.content) return;

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  LebbyAccordion.prototype.onClick = function (e) {
    e.preventDefault();

    // No-animation path (reduced motion / unsupported): just toggle.
    if (reduceMotion || typeof this.el.animate !== 'function') {
      this.el.open = !this.el.open;
      return;
    }

    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  };

  LebbyAccordion.prototype.shrink = function () {
    this.isClosing = true;
    var startHeight = this.el.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: DURATION, easing: 'ease' }
    );
    this.animation.onfinish = this.onFinish.bind(this, false);
    this.animation.oncancel = function () {
      this.isClosing = false;
    }.bind(this);
  };

  LebbyAccordion.prototype.open = function () {
    this.el.style.height = this.el.offsetHeight + 'px';
    this.el.open = true;
    window.requestAnimationFrame(this.expand.bind(this));
  };

  LebbyAccordion.prototype.expand = function () {
    this.isExpanding = true;
    var startHeight = this.el.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + this.content.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: DURATION, easing: 'ease' }
    );
    this.animation.onfinish = this.onFinish.bind(this, true);
    this.animation.oncancel = function () {
      this.isExpanding = false;
    }.bind(this);
  };

  LebbyAccordion.prototype.onFinish = function (open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  };

  function init() {
    var items = document.querySelectorAll('details.lebby-acc__item');
    for (var i = 0; i < items.length; i++) {
      new LebbyAccordion(items[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
